import * as React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

class Notfound extends React.Component {

    public constructor(props: any) {

        super(props);
        var page = document.location.pathname;
        window.ga('set', 'page', page);
        window.ga('send', 'pageview');
    }

    public render() {

        return (
            <div className="detail-view-wrapper">
                <Helmet>
                    <title>Nicht gefunden - Stellenanbieter.de</title>
                    <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
                </Helmet>

                <h1>Inhalt nicht gefunden</h1>

                <p>
                    Der von Ihnen angeforderte Inhalt ist nicht mehr verfügbar.
                </p>

                <p>
                    Bitte verwenden Sie die <Link to={`/jobs`}>Suche</Link>
                </p>

                {this.getAd()}
                {this.initAd()}

                <div className="back-to-search">
                    <Link to={`/jobs`}>Zurück zur Suche</Link>
                </div>

                {this.getAd()}
                {this.initAd()}

            </div>
        );
    }

    private getAd() {

        return (
            <div className="full-block">
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block' }}
                    data-ad-client="ca-pub-9629683982356381"
                    data-ad-slot="4763578003"
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                />
            </div>
        );
    }

    private initAd() {

        setTimeout(
            () => {
                window.adsbygoogle.push({});
            },
            500);
        return (<span />);
    }

}

export default Notfound;



// WEBPACK FOOTER //
// ./src/Notfound.tsx